<div mat-dialog-title class="flex">
  <h2>{{ title }}</h2>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content [formGroup]="form">
  <div class="row">
    <mat-form-field class="col-md-4">
      <mat-label>Is Rented?</mat-label>
      <mat-select formControlName="isRented" required>
        <mat-option [value]="true">Yes</mat-option>
        <mat-option [value]="false">No</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-md-4">
      <input matInput type="number" placeholder="Rent Amount ($)" name="rentAmount" formControlName="rentAmount" />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-md-4">
      <input matInput placeholder="Owner Name" formControlName="ownerName" required />
    </mat-form-field>

    <mat-form-field class="col-md-4">
      <input matInput placeholder="Manager Name" formControlName="managerName" required />
    </mat-form-field>

    <mat-form-field class="col-md-4">
      <input matInput placeholder="Contact Phone #" formControlName="contactPhone" required />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-md-12">
      <input matInput placeholder="Email" name="email" formControlName="email" required />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-md-8">
      <input matInput placeholder="Address" formControlName="address" required />
    </mat-form-field>

    <mat-form-field class="col-md-4">
      <input matInput placeholder="Unit Number" formControlName="unitNumber" />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-md-8">
      <input matInput placeholder="City" formControlName="city" required />
    </mat-form-field>

    <mat-form-field class="col-md-4">
      <input matInput placeholder="ZipCode" formControlName="zipCode" required />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-md-6">
      <input matInput placeholder="Latitude" formControlName="latitude" />
    </mat-form-field>

    <mat-form-field class="col-md-6">
      <input matInput placeholder="Longitude" formControlName="longitude" />
    </mat-form-field>
  </div>

  <div class="mb-2">
    <button class="mat-raised-button" (click)="close()">Close</button>
    <button class="mat-raised-button mat-primary ml-2" (click)="save()">Save</button>
  </div>
</mat-dialog-content>
